<template>
  <div style="margin: 48px 0 0">
    <div>
      <el-carousel :interval="300000" ref="slideCarousel">
        <el-carousel-item v-for="(item, i) in items" :key="i">
          <img :src="item.img" alt="" style="width: 100%" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="ttt" style="background: #f7f8fc">
      <div class="a_1">专属知识培训平台</div>
      <div class="a_2">
        提供丰富内容课程服务形式，助学互动工具，提升学习效率，建立闭环的培训体系
      </div>
      <img
        src="../assets/HelloWorld/liatu.png"
        alt=""
        style="width: 80%; margin-bottom: 24px"
      />
      <div class="one_e">
        <div class="one_f">
          <div class="one_g">全新课程培训提升体系</div>
        </div>
        <div class="one_h">多种形式学习内容提供 丰富学习路上的枯燥</div>
        <div class="one_i"></div>
        <div class="one_j">
          <img class="one_k" src="../assets/HelloWorld/duihao_3.png" alt="" />
          <div>丰富的图文，语音，视频录播课程形式，有效搭建课程体系</div>
        </div>
        <div class="one_j">
          <img class="one_k" src="../assets/HelloWorld/duihao_3.png" alt="" />
          <div>打卡式学习 配合课程表好学又好玩</div>
        </div>
        <div class="one_j">
          <img class="one_k" src="../assets/HelloWorld/duihao_3.png" alt="" />
          <div>全类目课程 保障课程质量 解锁课程新用处</div>
        </div>
        <div
          class="one_p"
          style="margin: 20px 0 0"
          @click="outerVisible = true"
        >
          了解详情
        </div>
      </div>
    </div>
    <div class="ttt" style="background: #fff">
      <div class="a_31">智能AI数字人技术，万种数字场景自由搭建</div>
      <div class="a_2">
        大米智课AI数字人产品功能，可实现自动批量视频生成与虚拟人直播
      </div>
    </div>
    <div class="one" style="margin: 0 0 16px">
      <div
        style="display: flex; justify-content: space-between; color: #666666"
        @click="dianji(1)"
      >
        <div style="display: flex">
          <img
            src="../assets/数字人/444.png"
            alt=""
            style="width: 22px; height: 22px; margin-right: 8px"
          />
          <div>数字人视频合成</div>
        </div>
        <i :class="['el-icon-arrow-up', sss1 ? 'accsd' : '']" />
      </div>
      <div :class="['acc', sss1 ? 'active' : '']">
        <img
          src="../assets/数字人/Group 250@2x.png"
          alt=""
          style="width: 100%"
        />
        <div class="one_2">
          支持灵活配置场景、声音
          动作、动效。轻松用数字人制作短视频，无需真人出镜，大批量视频生成。
        </div>
        <div class="a_61" style="margin: 0 0 8px">
          <el-link
            :href="http"
            target="_blank"
            style="width: 47%"
            @click.native="handleClick2"
          >
            <div
              style="
                color: #ffffff;
                background: linear-gradient(90deg, #eb6215 0%, #ebaf15 100%);
                width: 100%;
              "
            >
              免费体验
            </div>
          </el-link>
          <div
            style="color: #eb5b05; background: #fbf1ec"
            @click="outerVisible = true"
          >
            了解详情
          </div>
        </div>
      </div>
    </div>
    <div class="one" style="margin: 0 0 16px">
      <div
        style="display: flex; justify-content: space-between; color: #666666"
        @click="dianji(2)"
      >
        <div style="display: flex">
          <img
            src="../assets/数字人/22.png"
            alt=""
            style="width: 18px; height: 18px; margin-right: 8px; padding: 2px"
          />
          <div>数字人克隆</div>
        </div>
        <i :class="['el-icon-arrow-up', sss2 ? 'accsd' : '']" />
      </div>
      <div :class="['acc', sss2 ? 'active' : '']">
        <img src="../assets/数字人/2.png" alt="" style="width: 100%" />
        <div class="one_2">
          多种形态的
          AI数字人模型，用户可基于模型进行克隆，形打造后可用于IP形象的打造、视频的制作、直播及其它应用场景
        </div>
        <div class="a_61" style="margin: 0 0 8px">
          <el-link
            :href="http"
            target="_blank"
            style="width: 47%"
            @click.native="handleClick2"
          >
            <div
              style="
                color: #ffffff;
                background: linear-gradient(90deg, #eb6215 0%, #ebaf15 100%);
                width: 100%;
              "
            >
              免费体验
            </div>
          </el-link>
          <div
            style="color: #eb5b05; background: #fbf1ec"
            @click="outerVisible = true"
          >
            了解详情
          </div>
        </div>
      </div>
    </div>
    <div class="one" style="margin: 0 0 16px">
      <div
        style="display: flex; justify-content: space-between; color: #666666"
        @click="dianji(3)"
      >
        <div style="display: flex">
          <img
            src="../assets/数字人/Frame.png"
            alt=""
            style="width: 22px; height: 22px; margin-right: 8px"
          />
          <div>数字人直播</div>
        </div>
        <i :class="['el-icon-arrow-up', sss3 ? 'accsd' : '']" />
      </div>
      <div :class="['acc', sss3 ? 'active' : '']">
        <img src="../assets/数字人/3.png" alt="" style="width: 100%" />
        <div class="one_2">
          简易操作，可接入多个直播平台并具备弹幕、点赞、商品推送、录屏支持虚拟人自助直播，等多种互动功能
        </div>
        <div class="a_61" style="margin: 0 0 8px">
          <el-link
            :href="http"
            target="_blank"
            style="width: 47%"
            @click.native="handleClick2"
          >
            <div
              style="
                color: #ffffff;
                background: linear-gradient(90deg, #eb6215 0%, #ebaf15 100%);
                width: 100%;
              "
            >
              免费体验
            </div>
          </el-link>
          <div
            style="color: #eb5b05; background: #fbf1ec"
            @click="outerVisible = true"
          >
            了解详情
          </div>
        </div>
      </div>
    </div>
    <div class="one" style="margin: 0 0 16px">
      <div
        style="display: flex; justify-content: space-between; color: #666666"
        @click="dianji(4)"
      >
        <div style="display: flex">
          <img
            src="../assets/数字人/11.png"
            alt=""
            style="width: 18px; height: 18px; margin-right: 8px; padding: 2px"
          />
          <div>数字人交互</div>
        </div>
        <i :class="['el-icon-arrow-up', sss4 ? 'accsd' : '']" />
      </div>
      <div :class="['acc', sss4 ? 'active' : '']">
        <img src="../assets/数字人/1.png" alt="" style="width: 100%" />
        <div class="one_2">
          支持TTSA、STA、唱歌、DUIX交互能力等，支持动作捕捉、面部捕捉，也支持虚拟场景下，真人和数字人同时出场的虚拟直播。
        </div>
        <div class="a_61" style="margin: 0 0 8px">
          <el-link
            :href="http"
            target="_blank"
            style="width: 47%"
            @click.native="handleClick2"
          >
            <div
              style="
                color: #ffffff;
                background: linear-gradient(90deg, #eb6215 0%, #ebaf15 100%);
                width: 100%;
              "
            >
              免费体验
            </div>
          </el-link>
          <div
            style="color: #eb5b05; background: #fbf1ec"
            @click="outerVisible = true"
          >
            了解详情
          </div>
        </div>
      </div>
    </div>
    <div class="ttt" style="background: #fff">
      <div class="a_1">应用场景</div>
      <div class="a_2">
        数字人可以广泛应用于不同的行业领域,打破行业限制,结合箕多模态表现方提供更好的服务,赋能产业
      </div>
    </div>
    <div>
      <div class="a_33">
        <img src="../assets//数字人/Group 254.png" alt="" />
        <img src="../assets//数字人/Group 255.png" alt="" />
        <img src="../assets//数字人/Group 256.png" alt="" />
        <img src="../assets//数字人/Group 257.png" alt="" />
        <img src="../assets//数字人/Group 258.png" alt="" />
        <img
          src="../assets//数字人/Group 259.png"
          alt=""
          style="margin: 0 24px 0"
        />
      </div>
      <div
        class="one_p"
        style="margin: 30px 24px 0"
        @click="outerVisible = true"
      >
        了解详情
      </div>
    </div>
    <div class="ttt" style="background: #fff">
      <div class="a_3">化繁为简，减少企业对培训平台的学习成本</div>
      <div class="a_4">
        <div v-for="(item, i) in item1" :key="i" class="a_41">
          <img
            :src="item.img"
            alt=""
            style="width: 18px; height: 18px; margin: 0 8px 0 24px"
          />
          <div style="font-size: 14px">{{ item.title }}</div>
        </div>
      </div>
      <div class="one_p" style="margin: 20px 0 0" @click="outerVisible = true">
        了解详情
      </div>
    </div>
    <div
      class="ttt"
      style="background: linear-gradient(90deg, #f7f8fc 0, #ebf8fe 100%)"
    >
      <div class="a_1">行业解决方案</div>
      <div class="a_2">
        根据您的行业特点进行专属定制，提供专业的售前、搭建、培训和售后等服务，助力您轻松上手！
      </div>
      <div class="a_4">
        <img
          v-for="(item, i) in item2"
          :key="i"
          :src="item.img"
          alt=""
          class="a_42"
          @click="tupian(i)"
        />
      </div>
      <div class="one_p" style="margin: 20px 0 0" @click="outerVisible = true">
        了解详情
      </div>
    </div>
    <div class="ttt">
      <div class="a_1">人才分层</div>
      <div class="a_4">
        <div
          v-for="(item, i) in item3"
          :key="i"
          :class="[
            'a_43',
            'a_42',
            i == 0 ? 'd1' : '',
            i == 1 ? 'd2' : '',
            i == 2 ? 'd3' : '',
            i == 3 ? 'd4' : '',
          ]"
        >
          <div style="padding: 16px">
            <div class="a_44">{{ item.title }}</div>
            <div class="a_45">{{ item.name }}</div>
            <el-link
              href="https://affim.baidu.com/unique_49847201/mobile/chat?siteId=19538945&userId=49847201&siteToken=d938ff4f7bae9254e1d97e1fae316cf6"
              target="_self"
              style="width: 100%"
            >
              <div
                :class="[
                  'a_46',
                  i == 0 ? 's1' : '',
                  i == 1 ? 's2' : '',
                  i == 2 ? 's3' : '',
                  i == 3 ? 's4' : '',
                ]"
              >
                立即咨询
              </div>
            </el-link>
          </div>
        </div>
      </div>
    </div>
    <div
      class="ttt"
      style="background: linear-gradient(90deg, #f7f8fc 0, #ebf8fe 100%)"
    >
      <div class="a_1">不限行业，适合各种培训学习场景</div>
      <div class="a_2">
        支持内部多场景培训、知识萃取等，培训快速落地，做到培训有计划、有过程、有结果
      </div>
      <div class="a_4">
        <div v-for="(item, i) in item4" class="a_6">
          <img :src="item.img" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
      <div class="a_61">
        <el-link
          :href="http"
          target="_blank"
          style="width: 47%"
          @click.native="handleClick2"
        >
          <div
            style="
              color: #ffffff;
              background: linear-gradient(90deg, #eb6215 0%, #ebaf15 100%);
              width: 100%;
            "
          >
            免费体验
          </div>
        </el-link>
        <div
          style="color: #eb5b05; background: #fbf1ec"
          @click="outerVisible = true"
        >
          了解详情
        </div>
      </div>
    </div>
    <div style="width: 100%">
      <bottomVue></bottomVue>
    </div>
    <el-dialog
      title="外层 Dialog"
      width="90%"
      @close="handleClose2"
      :visible.sync="outerVisible"
    >
      <el-dialog
        width="90%"
        title="内层 Dialog"
        class="neiceng"
        :visible.sync="dialogVisible"
        append-to-body
        :before-close="handleClose"
      >
        <img
          src="../assets//HelloWorld//tankuang111.png"
          alt=""
          style="width: 114px; height: 112px; padding: 32px 0 16px"
        />
        <div class="xxx_top">提交成功 ！</div>
        <div class="xxx_topy">我们会尽快安排专属人员为您服务~</div>
        <div class="xxx_topu">
          <div class="xxx_topu22" @click="dialogVisibleTOP()">知道了</div>
        </div>
      </el-dialog>
      <div class="boss_2">免费获取行业解决方案</div>
      <div class="boss_3">已有 5187 家企业获取方案</div>
      <div class="boss_4" style="margin-top: 25px">
        <el-select
          v-model="value"
          :popper-append-to-body="false"
          filterable
          placeholder="请选择想了解的行业"
          style="width: 100%; border-radius: 4px"
        >
          <el-option
            v-for="item in schooList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div style="height: 21px">
        <div v-if="yanzheng2" class="errortext">请选择想了解的行业！</div>
      </div>
      <div class="boss_4">
        <el-input
          type="number"
          v-model.trim="input"
          placeholder="请输入联系电话"
          class="boss_41"
        />
        <div v-if="yanzheng" class="errortext">请正确填写联系方式！</div>
      </div>
      <div class="boss_5">提交即可获取30天免费试用</div>
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 10px;
        "
      >
        <div class="boss_6" @click="dianhuan()">提交</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bottomVue from '@/yidong/components/bottom.vue'
import { add, getIndustryList } from '@/api/util'
import { report } from '@/js/utils'

export default {
  name: 'HomeView',
  components: {
    bottomVue,
  },
  data() {
    return {
      sss1: true,
      sss2: false,
      sss3: false,
      sss4: false,
      http: this.$getCookie('http'),
      diyi_1: false,
      outerVisible: false, //外
      dialogVisible: false, //内
      schooList: [],
      yanzheng: false,
      yanzheng2: false,
      input: '',
      value: '',

      item1: [
        { img: require('../assets/yidong/11.png'), title: '内容管理' },
        { img: require('../assets/yidong/12.png'), title: '在线知识库' },
        { img: require('../assets/yidong/13.png'), title: '录播转存' },
        { img: require('../assets/yidong/14.png'), title: '在线测评' },
      ],
      item2: [
        { img: require('../assets/yidong/Group 193.png') },
        { img: require('../assets/yidong/Group 188.png') },
        { img: require('../assets/yidong/Group 189.png') },
        { img: require('../assets/yidong/Group 190.png') },
        { img: require('../assets/yidong/Group 191.png') },
        { img: require('../assets/yidong/Group 192.png') },
      ],
      item3: [
        { title: '岗前评估', name: '明晰员工能力水平胜任潜质' },
        { title: '专岗匹配', name: '精准匹配私属知识学习方案' },
        { title: '考核测评', name: '综合评估并形成可视化报告' },
        { title: '考核晋升', name: '明确的晋升管理通道和考核内容' },
      ],
      item4: [
        {
          img: require('../assets/HelloWorld/cahngjing/b_1.png'),
          title: '新员工培训',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_6.png'),
          title: '岗前培训',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_11.png'),
          title: '技能培训',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_16.png'),
          title: '混合式培训',
        },

        {
          img: require('../assets/HelloWorld/cahngjing/b_2.png'),
          title: '中高管培训',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_7.png'),
          title: '晋升培训',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_12.png'),
          title: '远程会训',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_17.png'),
          title: '公开课',
        },

        {
          img: require('../assets/HelloWorld/cahngjing/b_3.png'),
          title: '客户培训',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_8.png'),
          title: '渠道培训',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_13.png'),
          title: '教育培训',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_18.png'),
          title: '培训班',
        },

        {
          img: require('../assets/HelloWorld/cahngjing/b_4.png'),
          title: '社交化学习',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_9.png'),
          title: '小组学习',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_14.png'),
          title: '以考代训',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_19.png'),
          title: '专属化学习',
        },

        {
          img: require('../assets/HelloWorld/cahngjing/b_5.png'),
          title: '知识萃取',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_10.png'),
          title: '课程制作',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_15.png'),
          title: '企业知识库',
        },
        {
          img: require('../assets/HelloWorld/cahngjing/b_20.png'),
          title: '知识付费',
        },
      ],
      items: [
        { img: require('../assets/yidong/Group 246.png') },
        { img: require('../assets/yidong/Group 247.png') },
        { img: require('../assets/yidong/Group 248.png') },
      ],
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.slideBanner()
    this.getIndustryListTop()
  },
  methods: {
    dianji(i) {
      if (i == 1) {
        this.sss1 = !this.sss1
      }
      if (i == 2) {
        this.sss2 = !this.sss2
      }
      if (i == 3) {
        this.sss3 = !this.sss3
      }
      if (i == 4) {
        this.sss4 = !this.sss4
      }
    },
    handleClose2() {
      this.input = ''
      this.value = ''
      this.outerVisible = false
    },
    handleClick2(event) {
      this.$setItem('luyou', this.$route.path)
      report(true)
      this.$removeItem('shijian')
    },
    dialogVisibleTOP() {
      this.outerVisible = false
      this.dialogVisible = false
    },
    getIndustryListTop() {
      let that = this
      getIndustryList().then((res) => {
        let arr = []
        for (let i in res.data.data) {
          arr.push(res.data.data[i])
        }
        arr.map((item, index) => {
          that.schooList.push({ label: item.title, value: item.id })
        })
      })
    },
    dianhuan() {
      const ccc =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      if (!this.value) {
        this.yanzheng2 = true
      } else if (!ccc.test(this.input)) {
        this.yanzheng2 = false
        this.yanzheng = true
      } else {
        this.yanzheng = false
        let data = {
          phone: this.input,
          industryId: this.value,
          uuid: this.$getItem('result'),
        }
        add(data).then((res) => {
          if (res.data.code == 200) {
            this.input = ''
            this.value = ''
            this.dialogVisible = true
          } else {
            this.input = ''
            this.value = ''
            this.outerVisible = false
          }
        })
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },

    // 滑动切换
    slideBanner() {
      //选中的轮播图
      var box = document.querySelector('.el-carousel__container')
      var startPoint = 0
      var stopPoint = 0
      //重置坐标
      var resetPoint = function () {
        startPoint = 0
        stopPoint = 0
      }
      //手指按下
      box.addEventListener('touchstart', function (e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX
      })
      //手指滑动
      box.addEventListener('touchmove', function (e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX
      })
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this
      box.addEventListener('touchend', function (e) {
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint()
          return
        }
        if (startPoint - stopPoint > 0) {
          resetPoint()
          that.$refs.slideCarousel.next()
          return
        }
        if (startPoint - stopPoint < 0) {
          resetPoint()
          that.$refs.slideCarousel.prev()
          return
        }
      })
    },
    tupian(i) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      this.$setCookie('yiDong', i)
      this.$router.push('/schemeA')
      //  report(false)
    },
  },
  // 清空
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<style lang="scss" scoped>
* {
  ::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
}
.acc {
  max-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.5s ease;
  &.active {
    transition: all 0.5s ease;
    margin-top: 24px;
    max-height: 1000px;
  }
}
.accsd {
  transition: all 0.5s;
  transform: rotate(180deg);
}
::v-deep .el-icon-arrow-up {
  transition: all 0.5s;
  font-size: 24px;
  color: #4e4d4d;
}
.one {
  padding: 16px 24px;
  background: #f7f8fc;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  // border-radius: 4px 4px 4px 4px;
  margin-top: 24px;
}
.one_2 {
  margin: 30px 0;
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
}

::v-deep .el-link--inner {
  width: 100%;
  display: flex;
  justify-content: center;
}
::v-deep .el-carousel__container {
  // height: 57vh;
  height: calc(100vw + 100vw * 0.0133);
}
::v-deep .el-link--inner {
  width: 100%;
}
::v-deep .el-carousel__indicators--horizontal {
  bottom: 20%;
}

.neiceng ::v-deep .el-dialog {
  //  width:470px !important ;
  //  height: 320px !important;
  border-radius: 8px;
}
.neiceng ::v-deep .el-dialog__header {
  display: none;
}
.neiceng ::v-deep .el-dialog__body {
  text-align: center;
  padding: 0 0 25px;
}
.neiceng .xxx_top {
  height: 28px;
  font-size: 20px;
  font-weight: bold;
  color: #eb5b05;
  margin-bottom: 12px;
}
.neiceng .xxx_topy {
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  margin-bottom: 16px;
}
.neiceng .xxx_topu {
  display: flex;
  justify-content: center;
  height: 40px;
}
.neiceng .xxx_topu22 {
  width: 270px;
  height: 40px !important;
  background: #eb5b05;
  border-radius: 4px;
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  line-height: 40px;
  color: #ffffff;
}
::v-deep .el-dialog {
  border-radius: 10px;
}

::v-deep .el-dialog__header {
  display: none;
}
.boss_2 {
  color: #000;
  font-size: 20px;
  font-weight: 00;
  height: 28px;
  // margin-top: 20px;
  // line-height: 30px;
  text-align: center;
}
.boss_3 {
  align-items: center;
  color: #666666;
  /* -ms-flex-direction: row; */
  flex-direction: row;
  font-size: 16px;
  height: 22px;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  .boss_31 {
    background: #0075ff;
    border-radius: 4px;
    color: #fb6904;
    font-size: 16px;
    font-weight: 500;
    margin: 0 7px;
    padding: 3px 7px;
  }
}
.boss_5 {
  // margin: 2px 36px 0;
  color: #fb6904;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
}
.boss_6 {
  text-align: center;
  line-height: 40px;
  background: #eb6215;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  // cursor: pointer !important;
  font-weight: 500;
  height: 40px;
  width: 274px;
}
.errortext {
  color: #ee1c46;
  font-size: 14px;
  height: 21px;
  width: 100%;
  line-height: 21px;
}

.ttt {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 24px 24px;
}
.one_e {
  // margin: 34px 0 0 55px;
  width: 100%;
  .one_f {
    display: flex;
    color: #eb6315;
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 14px;
    .one_g {
      color: #333333;
    }
  }
  .one_h {
    min-height: 53px;
    line-height: 24px;
    color: #666666;
    font-weight: 400;
    border-bottom: 1px solid #999999;
  }
  .one_i {
    width: 24px;
    height: 3px;
    background: #000000;
    margin-top: -2px;
  }
  .one_j {
    margin-top: 28px;
    min-height: 24px;
    line-height: 24px;
    display: flex;
    font-weight: 400;
    color: #333333;
    .one_k {
      height: 24px;
      margin-right: 10px;
    }
  }
  /* .one_l {
          margin-top: 28px;
          height: 24px;
          line-height: 24px;
          display: flex;
          .one_m {
            height: 24px;
            margin-right: 10px;
          }
        }
        .one_n {
          margin-top: 28px;
          height: 24px;
          line-height: 24px;
          display: flex;
          .one_o {
            height: 24px;
            margin-right: 10px;
          }
        } */
}
.one_p {
  margin: 49px 0 0;
  font-size: 16px;
  font-weight: 400;
  width: calc(100vw - 48px);
  height: 48px;
  text-align: center;
  line-height: 48px;
  color: #ffffff;
  background: linear-gradient(90deg, #eb6215 0%, #ebaf15 100%);
}
.a_1 {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #121221;
  line-height: 21px;
  margin: 24px 0 18px;
}
.a_2 {
  line-height: 18px;
  font-weight: 400;
  color: #666666;
  font-size: 13px;
  line-height: 18px;
  margin: 0 0 24px;
  padding: 0 24px;
}
.a_3 {
  // height: 25px;
  font-size: 18px;
  font-weight: bold;
  color: #121221;
  line-height: 23px;
  margin: 24px 0;
}
.a_33 {
  display: flex;
  overflow: auto;
  width: 100vw;
  img {
    width: 70%;
    margin: 0 0 0 24px;
  }
}
.a_31 {
  // height: 25px;
  font-size: 18px;
  font-weight: bold;
  color: #121221;
  line-height: 23px;
  margin: 24px 0 16px;
}
.a_4 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.a_41 {
  display: flex;
  align-items: center;
  // padding: 0 24px;
  height: 44px;
  width: 47%;
  background: linear-gradient(360deg, #ffffff 0%, #fff9f4 100%);
  border-radius: 2px 2px 2px 2px;
  opacity: 1;
  border: 1px solid #fae2c8;
  margin-bottom: 16px;
}

.a_42 {
  width: 42vw;
  height: 42vw;
  margin-bottom: 16px;
}
.a_43 {
  // background: linear-gradient(90deg, #FF8D2F 0%, #FB753A 100%);
  // padding: 16px;
  border-radius: 5px;
}
.a_44 {
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  line-height: 21px;
  margin-bottom: 6px;
}
.a_45 {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  line-height: 17px;
  margin-bottom: 16px;
}
.a_46 {
  background: #ffffff;
  font-size: 14px;
  height: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.a_5 {
  display: flex;
  align-items: center;
  height: 18px;
  font-size: 13px;
  font-weight: 400;
  color: #3c89f6;
}
.a_6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 25%;
  margin-bottom: 30px;
  img {
    width: 24px;
    height: 24px;
    margin-bottom: 8px;
  }
  div {
    height: 18px;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
  }
}
.a_61 {
  display: flex;
  width: 100%;
  justify-content: space-between;
  div {
    width: 47%;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
  }
}
.d1 {
  background: linear-gradient(90deg, #ff8d2f 0%, #fb753a 100%);
}
.d2 {
  background: linear-gradient(90deg, #ffa183 0%, #f46f45 100%);
}
.d3 {
  background: linear-gradient(90deg, #efb81a 0%, #f69d32 100%);
}
.d4 {
  background: linear-gradient(90deg, #fec37d 0%, #f39e3a 100%);
}
.s1 {
  color: #eb6615;
}
.s2 {
  color: #f57249;
}
.s3 {
  color: #fe9918;
}
.s4 {
  color: #f09933;
}
</style>
